import React from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE } from "../lib/utils";

// Sticky mobile call CTA - visible on small screens only
export default function StickyCallBar() {
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      data-testid="sticky-mobile-call"
      className="lg:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-40 inline-flex items-center gap-2 px-5 py-3.5 bg-[#E91E63] text-white font-bold uppercase text-xs tracking-wider shadow-[0_8px_0_-2px_#0a0a0a] hover:-translate-y-0.5 transition-transform"
    >
      <Phone className="w-4 h-4" strokeWidth={3} />
      {PHONE}
    </a>
  );
}
